import { render, staticRenderFns } from "./PipeMaterialRadio.vue?vue&type=template&id=e5ccd0f4&scoped=true&"
import script from "./PipeMaterialRadio.vue?vue&type=script&lang=js&"
export * from "./PipeMaterialRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ccd0f4",
  null
  
)

export default component.exports